import React from 'react'

import { useQueryClient } from '@tanstack/react-query'
// import { resetQuickFilters } from '@screens/leads/resetQuickFilters'
import { PressableWithIntent } from '@zet/common/components/pressableWithIntent'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { Icon } from '@zet/design-system/icons'
import { Stack, XStack } from '@zet/design-system/layout'
import { B2, B5, SH1, SH3 } from '@zet/design-system/typography'
import { APP_NAME } from '@zet/end-points'
import {
  useAgentDashboardForBrands,
  useBrandDetailsById,
} from '@zet/feature-brands/api/brands/hooks'
import useLeadFilterStore from '@zet/feature-leads/store/leadFilter'
import { i18n } from '@zet/localization'
import { QuickFilter, zetStoreDpandaIds } from '@zet/utils/Constants'

const BrandTile = ({
  isHold,
  brandId,
}: {
  isHold?: boolean
  brandId: string | number
}) => {
  const { navigate } = useNavigation()
  const { data } = useAgentDashboardForBrands(brandId || '')

  const queryClient = useQueryClient()
  const { data: content } = useBrandDetailsById(brandId || '')
  const categoryId = content?.categoryId
  const brandName = content?.name

  const TILE_DATA = [
    brandId !== zetStoreDpandaIds.partnerId && {
      id: 'index-1',
      name: i18n.t('brandDetails.eligibleCust'),
      heading: data?.eligible,
      navigationScreen: 'BrandCustomers',
      iconName: 'UserGroupOutlined',
      eventName: 'click_action',
      eventPayload: {
        item_name: 'brands_list_brand_eligible_customers',
        brand_name: brandName,
        category_name: content?.subCategory,
      },
    },
    {
      id: 'index-2',
      name: i18n.t('brandDetails.totalLeads'),
      heading: data?.leads,
      navigationScreen: 'BrandCustomers',
      iconName: 'AssignedOutlined',
      eventName: 'click_action',
      eventPayload: {
        item_name: 'brands_list_brand_total_leads',
        brand_name: brandName,
        category_name: content?.subCategory,
      },
    },
  ].filter(Boolean)

  const leadFilterStore = useLeadFilterStore()

  return (
    <Stack className="border-grays-5 border-t-4 px-3">
      {APP_NAME === 'zet-app' && (
        <B2 className="text-grays-70 mt-3">
          {i18n.t('brandDetails.total')}{' '}
          <SH3 className="text-grays-100">{data?.amountEarned}</SH3>
          {i18n.t('brandDetails.earnedBrand')}
        </B2>
      )}
      <XStack className="my-3 justify-between">
        {TILE_DATA.map(
          (
            {
              id,
              heading,
              name,
              navigationScreen,
              eventName,
              eventPayload,
              iconName,
            },
            index
          ) => (
            <PressableWithIntent
              className={`border-grays-30 bg-grays-10 active:bg-grays-20 ${
                brandId === zetStoreDpandaIds.partnerId ? 'w-1/2' : 'flex-1'
              } rounded-lg border px-[10] py-2`}
              style={{
                marginLeft: index !== 0 ? 16 : 0,
              }}
              name={id === 'index-2' && 'LeadSummary'}
              key={id}
              onPress={() => {
                if (id === 'index-2') {
                  // resetQuickFilters()
                  leadFilterStore.resetLeadFilters()
                  QuickFilter['brands'].value = [brandId]
                  QuickFilter['category'].value = [categoryId]
                  leadFilterStore.updateFilter({
                    brands: [brandId],
                  })
                  leadFilterStore.updateFilter({
                    category: [categoryId],
                  })

                  queryClient.invalidateQueries({ queryKey: ['home-widgets'] })
                  queryClient.invalidateQueries({ queryKey: ['leads'] })

                  navigate('BrandLeads', {
                    brandName,
                  })
                } else
                  navigate(navigationScreen, {
                    brandId: brandId,
                    isHold,
                  })
              }}
              eventName={eventName}
              eventPayload={eventPayload}
            >
              <XStack className="items-center">
                <Stack className="rounded bg-[#DBEAFF] p-1">
                  <Icon type={iconName} color="#2075F0" />
                </Stack>
                <SH1 className="ml-2 grow">{heading}</SH1>
                <Stack>
                  <Icon type="ArrowRight" className="text-grays-80 -mr-2" />
                </Stack>
              </XStack>
              <B2 className="text-grays-80 pt-2">{name}</B2>
            </PressableWithIntent>
          )
        )}
      </XStack>
      {data?.potentialEarnings && APP_NAME === 'zet-app' ? (
        <B5 className="text-grays-50 pb-3">
          {i18n.t('brandDetails.potentialEarn', {
            amount: data.potentialEarnings,
          })}
        </B5>
      ) : (
        <></>
      )}
    </Stack>
  )
}

export default BrandTile
